import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const About = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#2D1735] to-[#5f40a1] text-white">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-16 max-w-6xl">
        {/* Intro Section */}
        <section className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
            About Cosmelytix
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            At Cosmelytix, we believe skincare should be as unique as you are. Our mission is to empower individuals 
            with personalized anti-age skincare and beauty recommendations based on smart ingredient analysis and scientific research.
          </p>
        </section>

        {/* Our Story */}
        <section className="mb-12 bg-white bg-opacity-10 backdrop-blur-md rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow">
          <h2 className="text-2xl font-semibold mb-4 text-[#E9A969]">Our Story</h2>
          <p className="text-gray-100 leading-relaxed">
            Founded by a team of skincare enthusiasts and tech innovators, Cosmelytix was born from the desire 
            to make skincare simple, effective, and personalized. We combine years of dermatological expertise 
            with advanced technology to guide you toward products that truly work for your skin.
          </p>
        </section>

        {/* Our Approach */}
        <section className="mb-12 bg-white bg-opacity-10 backdrop-blur-md rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow">
          <h2 className="text-2xl font-semibold mb-6 text-[#E9A969]">Our Approach</h2>
          <ul className="list-disc list-inside space-y-4 text-gray-100">
            <li>
              <strong>Science-Driven Analysis:</strong> We study ingredients, formulations, and skin profiles to recommend products backed by research.
            </li>
            <li>
              <strong>Personalized Recommendations:</strong> No two users are alike. Our smart system tailors advice to your skin type, age, and goals.
            </li>
            <li>
              <strong>Transparency & Trust:</strong> We provide clear information on ingredients and product efficacy, helping you make informed choices.
            </li>
          </ul>
        </section>

        {/* Our Commitment */}
        <section className="mb-12 bg-white bg-opacity-10 backdrop-blur-md rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow">
          <h2 className="text-2xl font-semibold mb-4 text-[#E9A969]">Our Commitment</h2>
          <p className="text-gray-100 leading-relaxed">
            We are committed to helping you achieve healthy, radiant, and youthful skin through a holistic approach 
            that blends technology and expert knowledge. Your skin journey is personal, and so is our guidance.
          </p>
        </section>

        {/* Call to Action */}
        <section className="text-center py-12 bg-white bg-opacity-10 backdrop-blur-md rounded-2xl shadow-lg hover:shadow-2xl transition-shadow">
          <h2 className="text-3xl font-bold mb-4 text-[#E9A969]">Get Started</h2>
          <p className="text-gray-100 mb-6 leading-relaxed">
            Discover your perfect skincare and beauty products today with Cosmelytix’s personalized recommendations.
          </p>
          <a
            href="/products"
            className="inline-block px-8 py-4 rounded-full bg-gradient-to-r from-[#c58348] to-[#d69e5b] text-white font-semibold text-lg shadow-lg hover:scale-105 transform transition-all duration-300"
          >
            Explore Products
          </a>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
